<template>
  <div
    class="antialiased"
    :dir="isRTL ? ELayoutDirection.RTL : ELayoutDirection.LTR"
  >
    <NuxtLayout>
      <NuxtPage />
    </NuxtLayout>
  </div>
</template>

<script setup lang="ts">
import { useRTL } from '~/composables/useRTL'

const { isRTL, ELayoutDirection } = useRTL()

useHead({
  script: [
    {
      type: 'application/ld+json',
      innerHTML: JSON.stringify({
        '@context': 'https://schema.org',
        '@graph': [
          {
            '@type': 'WebSite',
            '@id': 'https://risalahonline.com/#website',
            'url': 'https://risalahonline.com',
            'name': 'Risalah Online',
            'description': 'Read the Risale-i Nur Collection by Bediuzzaman Said Nursi online in 18 languages.',
            'inLanguage': ['en', 'ar', 'ms-Arab', 'mos', 'de', 'ru', 'fr', 'ms', 'fa', 'ha', 'ka', 'id', 'bn', 'ky', 'nl', 'ta', 'bs'],
            'potentialAction': {
              '@type': 'SearchAction',
              'target': {
                '@type': 'EntryPoint',
                'urlTemplate': 'https://risalahonline.com/search?q={search_term_string}'
              },
              'query-input': 'required name=search_term_string'
            }
          },
          {
            '@type': 'Organization',
            '@id': 'https://risalahonline.com/#organization',
            'name': 'Hayrat Vakfı',
            'url': 'https://hayratvakfi.org',
            'logo': {
              '@type': 'ImageObject',
              'url': 'https://risalahonline.com/RISALAH_ONLINE.png'
            },
            'sameAs': [
              'https://t.me/hayratvakfi',
              'https://instagram.com/hayratvakfi',
              'https://x.com/hayratvakfi',
              'https://facebook.com/hayratvakfi',
              'https://youtube.com/@hayratvakfi'
            ]
          }
        ]
      })
    }
  ]
})
</script>
